import { createContext, useContext } from 'react';
var DefaultAuthStrategy = /** @class */ (function () {
    function DefaultAuthStrategy() {
    }
    DefaultAuthStrategy.prototype.getRequestOptions = function () {
        return {
            withCredentials: true,
        };
    };
    DefaultAuthStrategy.prototype.onUnauthorized = function () {
        // Let the server decide where this session should be renewed. It knows how the session
        // was established; the browser cannot, because both cookies are httpOnly.
        //
        // An SSO user is returned to their identity provider and, while its session is alive, is
        // signed back in without typing anything — which is what the hosted UI used to do before
        // the custom page. Sending everyone to /login instead turned a lapsed session into a form
        // asking for an address we already knew.
        //
        // Everyone else is redirected on to /login by the same endpoint.
        globalThis.location.replace('/api/auth/reauth');
    };
    DefaultAuthStrategy.prototype.logout = function () {
        var _a;
        // Intentional sign-out: invalidate the Cognito SSO session then land on /login.
        globalThis.isLogout = true;
        globalThis.open((_a = process.env.REACT_APP_LOGOUT_URL) !== null && _a !== void 0 ? _a : '/api/auth/logout', '_self');
    };
    return DefaultAuthStrategy;
}());
export { DefaultAuthStrategy };
export var AuthContext = createContext(new DefaultAuthStrategy());
export var useAuthStrategy = function () {
    return useContext(AuthContext);
};
